<template>
  <div
    class="condition"
    :class="{'cursor-pointer' : isOnlyView}"
    @click="showInfo"
  >
    <div v-if="conditionStatus" class="condition__status">
      <a-badge
        :count="getStatusName(conditionStatus)"
        style="cursor: default; transform: scale(1.2);"
        :number-style="{
          backgroundColor: getBackgroundStatus(conditionStatus),
          boxShadow: '0 4px 8px 0 #d9d9d9',
        }"
      />
    </div>
    <div class="condition__title-block">
      <div class="condition__not-specified">
        <span :class="hasConditionTranslations ? 'truncate' : 'text-secondary'">
          {{ hasConditionTranslations ? defaultConditionTranslate : 'Not specified' }}
        </span>
      </div>
      <span><b>Condition</b> {{ conditionName }}<span v-if="conditionValue">: {{ conditionValue }}</span></span>
    </div>
    <div
      v-if="!isOnlyView && editPermission"
      class="d-flex align-items-center"
      style="height: fit-content; gap: 4px;"
    >
      <PingDot :show="error_validate" />
      <span
        class="text-primary cursor-pointer underline"
        @click="edit"
      >
        Edit
      </span>
    </div>
    <div
      v-if="isOnlyView"
      class="d-flex align-items-center"
    >
      <a-icon type="right" class="font-size-18 cursor-pointer" />
    </div>
  </div>
</template>

<script>
import PingDot from '@/views/apps/referral-program/components/PingDot.vue'
import { getConditionName } from '@/views/apps/referral-program/referral-programs/composables/useGetConditionName.js'
import { capitalizeFirstLetter } from '@/composables/useCapitalizeFirstLetter.js'
import { getConditionStatusColors } from '@/views/apps/referral-program/referral-programs/composables/useGetConditionStatusColors.js'

export default {
  props: {
    isOnlyView: {
      type: Boolean,
      default: false,
    },
    editPermission: {
      type: Boolean,
      default: false,
    },
    languagesUsed: {
      type: Array,
      default: () => [],
    },
    condition: {
      type: Object,
      default: () => {},
    },
    conditionValue: {
      type: [Number, null],
      default: null,
    },
  },
  components: {
    PingDot,
  },
  data: () => ({
    error_validate: false,
  }),
  watch: {
    condition: {
      handler() {
        this.error_validate = false
      },
      deep: true,
    },
  },
  computed: {
    defaultProgramLanguageId() {
      return this.languagesUsed.find(lang => lang.is_default)?.value
    },
    hasConditionTranslations() {
      return !!this.condition?.translations?.length
    },
    defaultConditionTranslate() {
      if (!this.hasConditionTranslations) {
        return ''
      }
      if (this.condition?.translations?.length === 1) {
        return this.condition?.translations[0].name
      }

      const defaultLanguageIndex = this.condition?.translations.findIndex(translation => translation.language_id === this.defaultProgramLanguageId)
      if (defaultLanguageIndex < 0) {
        return ''
      }

      return this.condition?.translations[defaultLanguageIndex].name
    },
    conditionName() {
      return getConditionName(this.condition?.type) || ''
    },
    conditionStatus() {
      return this.condition?.status || false
    },
  },
  methods: {
    getStatusName(status) {
      return capitalizeFirstLetter(status)
    },
    getBackgroundStatus(status) {
      return getConditionStatusColors(status)
    },
    showInfo() {
      if (!this.isOnlyView) {
        return
      }
      this.$emit('show')
    },
    edit() {
      this.$emit('edit')
    },
    async validateCodition() {
      return new Promise((resolve) => {
        if (!this.condition || !Array.isArray(this.condition.translations)) {
          this.error_validate = true
          resolve(false)
        }

        const filledLanguages = new Set(this.condition.translations.filter(t => t.name && t.name.trim() !== '').map(t => t.language_id))

        const requiredLanguagesIds = this.languagesUsed.map(lang => lang.value)
        const isValid = !requiredLanguagesIds.every(langId => filledLanguages.has(langId))

        this.error_validate = isValid
        resolve(isValid)
      })
    },
  },
}
</script>

<style lang="scss">
.condition {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 20px;
  border: 1px solid #e4e9f0;
  border-radius: 5px;
  background-color: #fff;
  &__status {
    position: absolute;
    right: 10px;
    top: -10px;
    z-index: 10;
  }
  &__title-block {
    display: flex;
    flex-direction: column;
    gap: 5px;
    overflow: hidden;
  }
  &__not-specified {
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 18px;
    & span {
      display: block;
      width: 430px;
    }
  }
}
</style>
